import { format } from 'path';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ExchangeRate } from 'src/app/models/exchange-rate.model';
import { ErrorResponse } from 'src/app/models/error.model';
import { CurrencyService } from 'src/app/services/currency.service';
import { Currency } from 'src/app/models/currency.model';
import * as moment from 'moment';

@Component({
  selector: 'app-new-exchange-rate-dialog',
  templateUrl: './new-exchange-rate-dialog.component.html',
  styleUrls: ['./new-exchange-rate-dialog.component.scss']
})
export class NewExchangeRateDialogComponent implements OnInit {

    newExchangeRateFG = new FormGroup({
        codigoMonedaBase: new FormControl<string | undefined>(undefined, [Validators.required]),
        codigoMonedaCambio: new FormControl<string | undefined>(undefined, [Validators.required]),
        fecha: new FormControl<string | undefined>({ value: moment().format('YYYY-MM-DD'), disabled: false }, [Validators.required]),
        cambio: new FormControl<number | undefined>(undefined, [Validators.required]),
    });

    currencies?: Currency[];

    constructor(
        private utilsService: UtilsService,
        private currencyService: CurrencyService,
        private exchangeRateService: ExchangeRateService,
        public dialogRef: MatDialogRef<NewExchangeRateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    ngOnInit(): void {
        this.getCurrency();
        this.newExchangeRateFG.get('codigoMonedaBase').setValue(this.data.codigoMonedaBase);
        this.newExchangeRateFG.get('codigoMonedaCambio').setValue(this.data.codigoMonedaCambio);

    }

    getCurrency() {
        this.currencyService.getCurrency().subscribe({
            next: response => {
                this.currencies = response;
            },
            error: (error: ErrorResponse) => {
                this.utilsService.alert('Error al obtener las monedas', error.error.descripcion);
            }
        });
    }

    compare = (op1: any | undefined, op2:  any | undefined ) => op1 === op2;

    cancel() {
        this.dialogRef.close(false);
    }

    createExchangeRate() {
        this.newExchangeRateFG.markAllAsTouched();
        if (!this.newExchangeRateFG.valid) return;

        const value = this.newExchangeRateFG.getRawValue();

        const valueExchangeRate: ExchangeRate = {
            codigoMonedaBase: value.codigoMonedaBase,
            codigoMonedaCambio: value.codigoMonedaCambio,
            fecha: value.fecha,
            cambio: value.cambio
        }
        this.exchangeRateService.postExchangeRate(valueExchangeRate).subscribe({
            next: response => {
                this.dialogRef.close(true);
            },
            error: (error: ErrorResponse) => {
                this.utilsService.alert('Error al crear el tipo de cambio', error.error?.descripcion);
            }
        });
    }
}
